import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";
import { BaseLayoutComponent } from "./layout/components/base-layout/base-layout.component";
import { SelectivePreloadingStrategyService } from "./selective-preloading-strategy.service";
import { CanvasComponent } from "./layout/components/canvas/canvas.component";
import { CanvasNoHeaderComponent } from "./layout/components/canvas-no-header/canvas-no-header.component";
import { RightPanelComponent } from "./layout/components/right-panel/right-panel.component";
import { ContainerRightPanelComponent } from "./layout/components/container-right-panel/container-right-panel.component";
import { SearchWorkflowsComponent } from "./modules/gfr-workflows/components/search-workflows/search-workflows.component";

const routes: Routes = [
  { path: 'home.html', children: []},
  { path: '', children: [] }, 
  {
    path: "dashboard",
    component: BaseLayoutComponent,
    children: [
      {
        path: "",
        component: CanvasComponent,
        children: [
          {
            path: "my-alerts",
            loadChildren: () =>
              import("./modules/gfr-my-alerts/gfr-my-alerts.module").then(
                (m) => m.GfrMyAlertsModule
              ),
          },

          {
            path: "my-work",
            loadChildren: () =>
              import("./modules/gfr-my-work/gfr-my-work.module").then(
                (m) => m.GfrMyWorkModule
              ),
            data: { preload: true },
          },
          {
            path: "my-links",
            loadChildren: () =>
              import("./modules/gfr-my-links/gfr-my-links.module").then(
                (m) => m.GfrMyLinksModule
              ),
            data: { preload: true },
          },
          {
            path: "my-documents",
            loadChildren: () =>
              import("./modules/gfr-my-documents/gfr-my-documents.module").then(
                (m) => m.GfrMyDocumentsModule
              ),
            data: { preload: true },
          },
        ],
      },
      {
        path: "no-header-canvas",
        component: CanvasNoHeaderComponent,
        children: [
          {
            path: "my-notifications",
            loadChildren: () =>
              import(
                "./modules/gfr-my-notifications/gfr-my-notifications.module"
              ).then((m) => m.GfrMyNotificationsModule),
            data: { preload: true },
          },
        ],
      },
    ],
  },
  //Non-Dashboard Projects, e/g - Tax Sort
  {
    path: "taxsort",
    component: BaseLayoutComponent,
    children: [
      {
        path: "",
        component: CanvasNoHeaderComponent,
        children: [
          {
            path: "",
            loadChildren: () =>
              import("./modules/gfr-tax-sort/gfr-tax-sort.module").then(
                (m) => m.GfrTaxSortModule
              ),
            data: { preload: true },
          },
        ],
      },
    ],
  },
  {
    path: "searchworkflows",
    loadChildren: () =>
      import("./modules/gfr-workflows/gfr-workflows.module").then(
        (m) => m.GfrWorkflowsModule
      ),
    data: { preload: true },
  },
  {
    path: "workflow-page",
    loadChildren: () =>
      import("./modules/gfr-workflow-page/gfr-workflow-page.module").then(
        (m) => m.GfrWorkflowPageModule
      ),
    data: { preload: true },
  },
  {
    path: "addWorkflow",
    loadChildren: () =>
      import("./modules/gfr-new-workflow/gfr-new-workflow.module").then(
        (m) => m.GfrNewWorkflowModule
      ),
    data: { preload: true },
  },
  {
    path: "taxFolder",
    loadChildren: () =>
      import("./modules/gfr-tax-folder/gfr-tax-folder.module").then(
        (m) => m.GfrTaxFolderModule
      ),
    data: { preload: true },
  },
  {
    path: "documentSearch",
    component: BaseLayoutComponent,
    children: [
      {
        path: "",
        component: CanvasNoHeaderComponent,
        children: [
          {
            path: "",
            loadChildren: () =>
              import(
                "./modules/gfr-document-search/gfr-document-search.module"
              ).then((m) => m.GfrDocumentSearchModule),
            data: { preload: true },
          },
        ],
      },
    ],
  },
  {
    path: "",
    loadChildren: () =>
      import(
        "./modules/gfr-events-administration/gfr-events-administration.module"
      ).then((m) => m.GfrEventsAdministrationModule),
      data: { preload: true },
  },




];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      enableTracing: true,
      preloadingStrategy: SelectivePreloadingStrategyService,
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
